import { FuelStop } from 'models/FuelStop';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const FuelStopActionType = {
    FETCH_FUELSTOPS: 'FETCH_FUELSTOP',
    FETCH_FUELSTOPS_SUCCESS: 'FETCH_FUELSTOP_SUCCESS',
    ADD_FUELSTOP: 'ADD_FUELSTOP',
    ADD_FUELSTOP_SUCCESS: 'ADD_FUELSTOP_SUCCESS',
    EDIT_FUELSTOP: 'EDIT_FUELSTOP',
    EDIT_FUELSTOP_SUCCESS: 'EDIT_FUELSTOP_SUCCESS',
    DELETE_FUELSTOP: 'DELETE_FUELSTOP',
    DELETE_FUELSTOP_SUCCESS: 'DELETE_FUELSTOP_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchFuelStopsAction {
    type: typeof FuelStopActionType.FETCH_FUELSTOPS
    payload: ApiPayload,
    returnPayload: FuelStop[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddFuelStopsAction {
    type: typeof FuelStopActionType.ADD_FUELSTOP
    payload: ApiPayload,
    returnPayload: FuelStop,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteFuelStopsAction {
    type: typeof FuelStopActionType.DELETE_FUELSTOP
    payload: ApiPayload,
    returnPayload: FuelStop,
    meta: {
        isApiCall: boolean
    },
}

export type IFuelStopActions = IFetchFuelStopsAction | IAddFuelStopsAction | IDeleteFuelStopsAction

const baseUrl = 'api/fuelStops';
export class FuelStopActions {
    public static fetchFuelStops(token: string): IFuelStopActions {
        return {
            type: FuelStopActionType.FETCH_FUELSTOPS,
            payload: Api.fetchApiCall(baseUrl, token, FuelStopActionType.FETCH_FUELSTOPS_SUCCESS, FuelStopActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addFuelStop(token: string, fuelStop: FuelStop): IFuelStopActions {
        return {
            type: FuelStopActionType.ADD_FUELSTOP,
            payload: Api.postApiCall(baseUrl, token, FuelStopActionType.ADD_FUELSTOP_SUCCESS, FuelStopActionType.API_ERROR, fuelStop),
            returnPayload: FuelStop.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static editFuelStop(token: string, fuelStop: FuelStop): IFuelStopActions {
        return {
            type: FuelStopActionType.EDIT_FUELSTOP,
            payload: Api.putApiCall(baseUrl + '/' + fuelStop.id, token, FuelStopActionType.EDIT_FUELSTOP_SUCCESS, FuelStopActionType.API_ERROR, fuelStop),
            returnPayload: FuelStop.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteFuelStop(token: string, id: number): IFuelStopActions {
        return {
            type: FuelStopActionType.DELETE_FUELSTOP,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, FuelStopActionType.DELETE_FUELSTOP_SUCCESS, FuelStopActionType.API_ERROR, true),
            returnPayload: FuelStop.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

}
